import type { ComponentProps, ReactNode } from 'react'
import { cn } from '../lib/cn'
import { Spinner } from './spinner'
import { Heading, Text } from './typography'
export function StateView({
  state,
  placement = 'panel',
  className,
  heading,
  description,
  icon,
  actions,
  children,
  ...props
}: Omit<ComponentProps<'div'>, 'role'> & {
  state: 'loading' | 'error' | 'empty' | 'no-results' | 'unselected' | 'unavailable'
  placement?: 'inline' | 'panel' | 'page'
  heading?: ReactNode
  description?: ReactNode
  icon?: ReactNode
  actions?: ReactNode
}) {
  return (
    <div
      {...props}
      data-slot="state-view"
      role={state === 'error' ? 'alert' : state === 'loading' ? 'status' : undefined}
      aria-busy={state === 'loading' || undefined}
      className={cn(
        'flex min-w-0 flex-col items-center justify-center gap-3 text-center text-sm',
        placement === 'inline'
          ? 'py-3'
          : placement === 'page'
            ? 'min-h-80 flex-1 py-16'
            : 'min-h-48 rounded-panel border border-border bg-card p-6',
        state === 'error' ? 'text-danger-foreground' : 'text-muted-foreground',
        className,
      )}
    >
      {state === 'loading' ? (
        <Spinner size="md" />
      ) : icon ? (
        <span aria-hidden="true" className="text-action [&>svg]:size-7">
          {icon}
        </span>
      ) : null}
      {heading ? (
        <Heading size="sm" className="text-foreground">
          {heading}
        </Heading>
      ) : null}
      {description ? (
        <Text tone="muted" className="max-w-md">
          {description}
        </Text>
      ) : null}
      {children}
      {actions ? <div className="mt-2 flex flex-wrap justify-center gap-2">{actions}</div> : null}
    </div>
  )
}
